// เชิญประชุม: แก้ไขวัตถุประสงค์บริษัท (Amendment of Objectives)

import React from "react";
import PrintField from "../../shared/PrintField";
import "./MeetingregardingAmendmentofObjectives.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const MeetingregardingAmendmentofObjectives = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      {/* ref ต้องเกาะที่ A4 */}
      <div className="inv-paper" ref={ref}>
        {/* Header right */}
        <div className="inv-header-right">
          <div className="inv-bold">
            บริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "200px" }}
              spellCheck={false}
            />
          </div>

          <div className="inv-header-date inv-bold">
            วันที่{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />
          </div>
        </div>

        <div className="inv-body">
          {/* เรื่อง */}
          <div className="inv-row">
            <span className="inv-bold">
              เรื่อง&nbsp;&nbsp;เชิญประชุมสามัญผู้ถือหุ้นประจำปี ครั้งที่
            </span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />
            <span className="inv-sep">/</span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />
          </div>

          {/* เรียน */}
          <div className="inv-row inv-row-learn inv-bold">
            เรียน&nbsp;&nbsp;ท่านผู้ถือหุ้นบริษัท{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "140px" }}
              spellCheck={false}
            />
          </div>

          {/* เนื้อหา */}
          <p className="inv-paragraph">
            ด้วยที่ประชุมคณะกรรมการบริษัท{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "160px" }}
              spellCheck={false}
            />{" "}
            ได้ลงมติให้เรียกเชิญประชุมวิสามัญผู้ถือหุ้นประจำปี
            
            ครั้งที่{" "}
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />
            <span className="inv-sep">/</span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            ในวันที่{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "70px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            เวลา{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            น.
            
            ณ สำนักงานของบริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "140px" }}
              spellCheck={false}
            />{" "}
            โดยมีระเบียบวาระการประชุมดังนี้ คือ
          </p>

          {/* วาระประชุม (แก้ไขวัตถุประสงค์) */}
          <div className="inv-agenda">
            <div className="inv-agenda-item">
              วาระที่ 1 พิจารณาเรื่องแก้ไขเพิ่มเติมวัตถุประสงค์ของบริษัท
            </div>           

            <div className="inv-agenda-item">
              วาระที่ 2 พิจารณาเรื่องแก้ไขเพิ่มเติมหนังสือบริคณฑ์สนธิ ข้อ.3
            </div>

            <div className="inv-agenda-item">
              วาระที่ 3 {" "}
             <InputField
              className="inv-line inv-line-long"
              style={{ width: "140px" }}
            />
            </div>

            <div className="inv-agenda-item">
              วาระที่ 4 พิจารณาเรื่องอื่นๆ ถ้ามี
            </div>
          </div>

          {/* ปิดท้าย */}
          <p className="inv-paragraph">
            ดังนั้น จึงขอเรียนเชิญท่านผู้ถือหุ้นไปประชุมตามวัน เวลา และสถานที่ดังกล่าวข้างต้น
            โดยพร้อมเพียงกันด้วย จักขอบคุณยิ่ง
          </p>

          {/* ลายเซ็น */}
          <div className="inv-footer">
            <div className="inv-footer-text">ขอแสดงความนับถือ</div>

            <div className="inv-sign-block">
              <InputField className="inv-sign-line" spellCheck={false} optional />
              <div className="inv-sign-name">
                ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              </div>
              <div className="inv-sign-role">กรรมการ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default MeetingregardingAmendmentofObjectives;
